import { useState } from "react";
import { useTranslation } from "react-i18next";
import PageLayout from "components/layout/PageLayout";
import { useGetCompanyLogQuery } from "./api/logApiSlice";
import LogTable from "./components/LogTable";

const CompanyLog = () => {
    const [t] = useTranslation(["global"]);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(25); // Page size dinamico

    const { data: companyLog, isFetching, isError, error, refetch } = useGetCompanyLogQuery({
        pageNumber,
        pageSize,
    });

    return (
        <PageLayout
            pageTitle={t("menu.log")}
            onPageRefresh={refetch}
            isLoadingContent={isFetching}
            bodyContent={
                companyLog ? (
                    <LogTable
                        logData={companyLog.content}
                        totalElements={companyLog.totalElements}
                        totalPages={companyLog.totalPages}
                        currentPage={pageNumber}
                        pageSize={pageSize}
                        onPageChange={setPageNumber}
                        onPageSizeChange={setPageSize} // Permettiamo il cambio page size
                    />
                ) : isError ? (
                    <p>{JSON.stringify(error)}</p>
                ) : null
            }
        />
    );
};

export default CompanyLog;
